import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { interval, Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
    selector: 'app-proyects',
    templateUrl: './proyects.component.html',
    styleUrls: ['./proyects.component.scss'],
    standalone: false
})
export class ProyectsComponent implements OnInit {
currentImage: string;
  private imageSubscription: Subscription;
  private readonly delayMs = 3000; // Retardo de 3 segundo
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    items: 1,
    margin: 10,
    autoplay: true,
    autoplayTimeout:3000,
    nav: true
  }


  @ViewChild('imgContainer') imgContainer: ElementRef;


  constructor(
    public analyticsService: AnalyticsService
  ) { }
randomIndex =0
 images: string[] = [
    
        "assets/images/electricidad/20241224_165830.jpg",
        "assets/images/electricidad/20250424_101301.jpg",
        "assets/images/electricidad/20250425_003035.jpg",
        "assets/images/electricidad/20250429_173228.jpg"
        
    // Agrega más rutas de imágenes aquí
  ];

  ngOnInit(): void {

   this.changeImage(); // Mostrar una imagen inmediatamente al cargar
 // Configurar un intervalo para cambiar la imagen periódicamente
    this.imageSubscription = interval(this.delayMs)
      .subscribe(() => {
        this.changeImage();
      });
  }
    ngOnDestroy(): void {
    // Limpiar la suscripción para evitar fugas de memoria
    if (this.imageSubscription) {
      this.imageSubscription.unsubscribe();
    }
  }


  changeImage(): void {
     this.randomIndex = Math.floor(Math.random() * this.images.length);
    this.currentImage = this.images[this.randomIndex];
  }


  debug(){

  this.imgContainer.nativeElement.scroll({
    top: this.imgContainer.nativeElement.scrollHeight,
    left: 0,
    behavior: 'smooth',    
  });
}


}
